import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '../assets/blutdruck.png'


const _hoisted_1 = { class: "home" }
const _hoisted_2 = { class: "hero" }
const _hoisted_3 = { class: "hero-content" }
const _hoisted_4 = { class: "hero-buttons" }
const _hoisted_5 = {
  href: "tel:+4906975009899",
  class: "secondary-btn"
}
const _hoisted_6 = {
  href: "https://wa.me/491702177193",
  target: "_blank",
  rel: "noopener",
  class: "whatsapp-btn"
}
const _hoisted_7 = { class: "services-preview" }
const _hoisted_8 = { class: "services-grid" }
const _hoisted_9 = { class: "service-icon" }
const _hoisted_10 = { class: "service-icon" }
const _hoisted_11 = { class: "service-icon" }
const _hoisted_12 = { class: "about-preview" }
const _hoisted_13 = { class: "about-left" }

import {Activity, Calendar, HeartPulse, Phone, ShieldPlus, Smartphone} from "lucide-vue-next";

import "@/assets/styles/home.css";

export default /*@__PURE__*/_defineComponent({
  __name: 'HomeView',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("section", _hoisted_2, [
      _cache[6] || (_cache[6] = _createElementVNode("div", { class: "hero-overlay" }, null, -1)),
      _createElementVNode("div", _hoisted_3, [
        _cache[3] || (_cache[3] = _createElementVNode("span", { class: "hero-badge" }, " Ambulante Pflege & Betreuung ", -1)),
        _cache[4] || (_cache[4] = _createElementVNode("h1", null, [
          _createTextVNode(" Fürsorge, die"),
          _createElementVNode("br"),
          _createTextVNode(" von Herzen kommt ")
        ], -1)),
        _cache[5] || (_cache[5] = _createElementVNode("p", null, " Menschliche Pflege, medizinische Betreuung und persönliche Unterstützung für ein sicheres Leben zuhause. ", -1)),
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_router_link, {
            to: "/contact",
            class: "primary-btn"
          }, {
            default: _withCtx(() => [
              _createVNode(_unref(Calendar)),
              _cache[0] || (_cache[0] = _createTextVNode(" Pflegeberatung anfragen ", -1))
            ]),
            _: 1
          }),
          _createElementVNode("a", _hoisted_5, [
            _createVNode(_unref(Phone)),
            _cache[1] || (_cache[1] = _createTextVNode(" Jetzt anrufen ", -1))
          ]),
          _createElementVNode("a", _hoisted_6, [
            _createVNode(_unref(Smartphone)),
            _cache[2] || (_cache[2] = _createTextVNode(" Kontakt über WhatsApp ", -1))
          ])
        ])
      ])
    ]),
    _createElementVNode("section", _hoisted_7, [
      _cache[13] || (_cache[13] = _createElementVNode("div", { class: "section-header" }, [
        _createElementVNode("span", null, "Unsere Leistungen"),
        _createElementVNode("h2", null, "Professionelle Pflege mit Herz")
      ], -1)),
      _createElementVNode("div", _hoisted_8, [
        _createVNode(_component_router_link, {
          to: "/services",
          class: "service-card"
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_9, [
              _createVNode(_unref(HeartPulse))
            ]),
            _cache[7] || (_cache[7] = _createElementVNode("h3", null, "SGB XI – Pflegeleistungen", -1)),
            _cache[8] || (_cache[8] = _createElementVNode("p", null, " Unterstützung im Alltag und bei der häuslichen Pflege – individuell, zuverlässig und auf die persönlichen Bedürfnisse abgestimmt. Dazu gehören pflegerische Hilfen, Entlastungsangebote sowie die Betreuung von pflegebedürftigen Menschen im häuslichen Umfeld. ", -1))
          ]),
          _: 1
        }),
        _createVNode(_component_router_link, {
          to: "/services",
          class: "service-card"
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_10, [
              _createVNode(_unref(Activity))
            ]),
            _cache[9] || (_cache[9] = _createElementVNode("h3", null, "SGB V – Behandlungspflege", -1)),
            _cache[10] || (_cache[10] = _createElementVNode("p", null, " Medizinische Versorgung nach ärztlicher Verordnung direkt bei Ihnen zuhause. Wir übernehmen professionelle behandlungspflegerische Maßnahmen mit fachlicher Kompetenz, Sorgfalt und persönlicher Betreuung. ", -1))
          ]),
          _: 1
        }),
        _createVNode(_component_router_link, {
          to: "/services",
          class: "service-card"
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_11, [
              _createVNode(_unref(ShieldPlus))
            ]),
            _cache[11] || (_cache[11] = _createElementVNode("h3", null, "Beratung & Unterstützung", -1)),
            _cache[12] || (_cache[12] = _createElementVNode("p", null, " Kompetente Beratung rund um Pflegegrade, Pflegeleistungen und Einstufungsgespräche. Wir begleiten Angehörige und Betroffene zuverlässig bei organisatorischen und pflegerischen Fragen. ", -1))
          ]),
          _: 1
        })
      ])
    ]),
    _createElementVNode("section", _hoisted_12, [
      _createElementVNode("div", _hoisted_13, [
        _cache[15] || (_cache[15] = _createElementVNode("span", { class: "section-badge" }, " Über uns ", -1)),
        _cache[16] || (_cache[16] = _createElementVNode("h2", null, " Pflege bedeutet Vertrauen, Respekt und Menschlichkeit ", -1)),
        _cache[17] || (_cache[17] = _createElementVNode("p", null, " Seit vielen Jahren begleiten wir Menschen im Alltag und unterstützen Familien mit zuverlässiger ambulanter Pflege. ", -1)),
        _cache[18] || (_cache[18] = _createElementVNode("p", null, " Unser Ziel ist es, Menschen ein würdevolles, sicheres und selbstbestimmtes Leben in ihrer gewohnten Umgebung zu ermöglichen. ", -1)),
        _createVNode(_component_router_link, {
          to: "/about",
          class: "about-btn"
        }, {
          default: _withCtx(() => [...(_cache[14] || (_cache[14] = [
            _createTextVNode(" Mehr erfahren ", -1)
          ]))]),
          _: 1
        })
      ]),
      _cache[19] || (_cache[19] = _createElementVNode("div", { class: "about-right" }, [
        _createElementVNode("img", {
          src: _imports_0,
          alt: "Pflegedienst Team"
        })
      ], -1))
    ]),
    _cache[20] || (_cache[20] = _createStaticVNode("<section class=\"contact-banner\"><div class=\"contact-wrapper\"><div class=\"contact-info\"><span class=\"section-badge\"> Kontakt </span><h2> Wir sind persönlich für Sie da </h2><p class=\"contact-text\"> Kontaktieren Sie uns telefonisch oder besuchen Sie uns an unserem Servicebüro in der Herxheimer-Straße. </p><div class=\"location-card\"><h3> Standort 1 – Verwaltung </h3><p>Am Niedwald 53</p><p>65933 Frankfurt am Main</p><span> Postanschrift und Schriftverkehr </span></div><div class=\"location-card\"><h3> Standort 2 – Servicebüro </h3><p>Herxheimerstraße 17</p><p>60326 Frankfurt am Main</p><span> Kundenempfang und Beratung </span></div></div><div class=\"contact-side\"><div class=\"contact-side-card\"><h3>Telefon</h3><a href=\"tel:+4906975009899\"> 069 7500 9899 </a></div><div class=\"contact-side-card\"><h3>Öffnungszeiten</h3><ul><li><span>Mo. – Mi.</span><span>10:00 – 16:00 Uhr</span></li><li><span>Weitere Termine</span><span>nach Vereinbarung</span></li></ul></div></div></div></section>", 1))
  ]))
}
}

})